<template>
  <v-card elevation="0" v-if="events && events.length > 0">
    <v-card-title
      class="display-1 font-weight-bold col col-12 text-left text--primary pa-0 mb-8"
    >
      {{ $t("dashboard.eventManager") }}
      <legend-tool :list="listLegend"></legend-tool></v-card-title
    ><v-card-text>
      <v-virtual-scroll
        :items="eventos"
        :item-height="$vuetify.breakpoint.mdAndUp ? 100 : 180"
        height="500"
      >
        <template v-slot="{ item }">
          <base-material-alert
            class="my-0"
            :color="item.color ? item.color : '#121212'"
            dark
            @click="$router.push({ path: `/${item.link}` })"
          >
            <span
              class="text-uppercase font-weight-bold"
              v-text="translate(item.title)"
            />
            —{{ translate(item.message) }}<br />
            <span class="caption">
              {{
                new Intl.DateTimeFormat("es-VE", {
                  dateStyle: "short",
                  timeStyle: "long"
                }).format(item.date.toDate())
              }}</span
            >
          </base-material-alert></template
        >
      </v-virtual-scroll>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
export default {
  name: "DashboardNotifications",
  components: {
    "legend-tool": () => import("@/components/LegendTool")
  },
  data() {
    const color = this.$vuetify.theme.themes.dark;
    return {
      listLegend: [
        {
          title: "Alarm Zone / Failure",
          color: color.failure
        },
        {
          title: "Maintenance",
          color: color.maintenance
        },
        {
          title: "Warning Zone / Standby",
          color: color.standby
        },
        {
          title: "Smooth Zone / Running",
          color: color.running
        }
      ]
    };
  },

  computed: {
    eventos() {
      let result = _.chain(this.events)
        .sortBy(e => e.date.seconds * 1000)
        .value()
        .reverse();
      return result;
    },
    ...mapState("events", ["events"])
  },
  methods: {
    translate: function(item) {
      var temp = item;

      temp = temp.replace(
        "New Inspection",
        this.$t("dashboard.eventTitleInspection")
      );
      temp = temp.replace(
        "RELIABILITY REPORT",
        this.$t("dashboard.eventTitleReliability")
      );
      temp = temp.replace(
        "There is a new inspection with a status",
        this.$t("dashboard.eventMessage.inspection")
      );
      temp = temp.replace(
        "There is a new reliability report with a status",
        this.$t("dashboard.eventMessage.reliability")
      );

      temp = temp.replace("SMOOTH", this.$t("reliability.conditions.smooth"));
      temp = temp.replace("WARNING", this.$t("reliability.conditions.warning"));
      temp = temp.replace("ALARM", this.$t("reliability.conditions.alarm"));

      temp = temp.replace(
        "RUNNING",
        this.$t("reliability.statuslights.running")
      );
      temp = temp.replace(
        "RUNNING",
        this.$t("reliability.statuslights.running")
      );
      temp = temp.replace(
        "STANDBY",
        this.$t("reliability.statuslights.standby")
      );
      temp = temp.replace(
        "MAINTENANCE",
        this.$t("reliability.statuslights.maintenance")
      );
      temp = temp.replace(
        "FAILURE",
        this.$t("reliability.statuslights.failure")
      );

      temp = temp.replace("and", this.$t("dashboard.eventMessage.and"));

      temp = temp.replace(
        "mechanical condition",
        this.$t("dashboard.mechanincalCondition")
      );

      return temp;
    }
  }
};
</script>
